/**
 * A function that takes a language code and returns a Mentorship Agreement URL in a correspondent Language.
 *
 * @param {string} programLanguageCode - Code of program/mentorship language.
 * @returns {string} - A URL of the file.
 */

import { languages } from 'utils/translationHandlers';

export default languageCode => {
  switch (languageCode) {
    case languages.ES:
      // Spanish
      return 'https://s3.amazonaws.com/assets.bridgeforbillions.org/docs/ES+-+Mentorship+Agreement.pdf';
    case languages.FR:
      // French
      return 'https://s3.amazonaws.com/assets.bridgeforbillions.org/docs/FR+-+Mentorship+Agreement.pdf';
    case languages.PT:
      // Portuguese
      return 'https://s3.amazonaws.com/assets.bridgeforbillions.org/docs/PT+-+Mentorship+Agreement.pdf';
    case languages.BR:
      // Brasilian Portuguese
      return 'https://s3.amazonaws.com/assets.bridgeforbillions.org/docs/PT+-+Mentorship+Agreement.pdf';
    case languages.IT:
      // Italian
      return 'https://s3.amazonaws.com/assets.bridgeforbillions.org/docs/IT+-+Mentorship%2BAgreement.pdf';
    default:
      // English
      return 'https://s3.amazonaws.com/assets.bridgeforbillions.org/docs/EN+-+Mentorship+Agreement.pdf';
  }
};
